import {isArray} from "lodash"

import mapValidKeys from "./mapValidKeys"


export default (teams) => {
  if (!isArray(teams)) return teams

  return teams.map((team) => mapValidKeys(team, {uuid: "value", public_name: "label"}))
}
